<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="订单明细"   fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<div class="card">
				<table class="layout">
					<tr style="width: 100%;">
						<td style="width: 60%;">
							<div class="header">
								<span class="title">{{serialNumber}}</span>
							</div>
						</td>
						<td style="width: 40%;text-align: center;">
							<span class="title" style="color: red;">{{orderStatus}}</span>
						</td>
					</tr>
					<tr style="width: 100%;padding-left: 20px;">
						<td colspan="2" class="content" style="width: 100%;">
							<p><span>用户姓名：</span><span>{{order.customerName}}</span></p>
							<p><span>联系方式：</span><span>{{order.arrivalMobile}}</span></p>
							<p style="width: 100%;"><span>安装地址：</span><span>{{order.arrivalAddress}}</span></p>
						</td>
					</tr>
				</table>
			</div>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top: 0;">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="">
					<div v-for="(item, index) in list" class="card" :key="item.uuid">
						<table class="layout">
							<tr style="width: 100%;" >
								<td style="width: 40%;" @click="editSkuInfo(item.uuid, item.radId)">
									<van-image
											width="150"
											height="140"
											:src="item.imageUrl"
									/>
								</td>
								<td style="padding-left: 10px;">
									<p>
										<span style="font-size: 16px; font-weight: bold">{{item.radIdname}}</span><br/>
										<span style="font-size: 12px;">代码:{{item.model}}</span><br/>
										<span style="font-size: 12px;">中心距:{{item.centerSpacing}}</span><br/>
										<span style="font-size: 12px;">颜色:{{item.colorname}}</span><br/>
										<span style="font-size: 12px;">接口口径:{{item.calibername}}</span><br/>
										<span style="font-size: 12px;">进水方式:{{item.waterFlowname}}</span><br/>
										<span style="font-size: 12px;">特殊进水方式:{{item.isSpecials}}</span><br/>
										<span style="font-size: 12px;">备注:{{item.mainRemark}}</span><br/>
									</p>
								</td>
							</tr>
							<tr style="width: 100%;">
								<td style="width: 40%;text-align: right" class="content">
									<p v-if="isLeader === '1' || checkPermission('查看销售单价')"><span style="color: #ff3300">成本价:{{item.price}}</span></p>
									<p><span>¥{{item.costPrice}}</span></p>
									<p><span>×{{item.pieces}}(片)&nbsp;&nbsp;每组¥{{item.costUnitedPrice}}</span></p>
								</td>
								<td style="width: 40%;text-align: right" class="content">
									<p><span style="font-size: 16px;font-weight: bold;">¥{{item.costSubtotal}}</span></p>
									<p><span>×{{item.quantity}}(组)</span></p>
								</td>
							</tr>
						</table>
					</div>
				</van-list>
			</van-pull-refresh>
			<div class="card">
				<table style="width: 100%;margin-bottom: 3px;border-spacing:0;padding: 20px;">
					<tr style="height:35px;">
						<td class="content">
							<p><span>下单人:</span><span>{{staffName}}</span></p>
							<p><span>{{order.createTime}}</span></p>
						</td>
						<td class="content" style="font-size: 16px;">
							<p><span>共{{order.mainQuantities}}组,合计:¥{{order.mainCostAmount}}</span></p>
							<p v-if="isLeader === '1'"><span style="color: #ff3300">成本价:{{order.mainAmount}}</span></p>
						</td>
					</tr>
				</table>
			</div>
			<van-popup v-model="showEditType" position="bottom" :style="{ height: '30%' }"
					   :close-on-click-overlay="false" >
				<table class="layout">
					<tr>
						<td>
							<van-button type="default" size="large" @click="updateOrderInfo()">修改订单</van-button>
						</td>
					</tr>
					<tr>
						<td>
							<van-button type="default" size="large" @click="deleteOrderSku()">删除产品</van-button>
						</td>
					</tr>
					<tr>
						<td>
							<van-button type="default" size="large" @click="cancelEditSku()">取消</van-button>
						</td>
					</tr>
				</table>
			</van-popup>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Field, Panel, Button, List, Image, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import {API_URL} from "../../common/config";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				uuid: "",
				isLeader: "",
				serialNumber: "",
				orderStatus: "",
				staffName: "",
				imageUrl: API_URL + "/oa/common/attachment/showImage?id=",
				order: {},
				isEditable: false,
				groupId: "",
				showEditType: false,
				editDetailId: "",
				editRadId: ""
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
            [Field.name]: Field,
			[NavBar.name]: NavBar,
			[Image.name]: Image,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: async function () {
			this.uuid = this.$route.query.uuid || "";
			this.serialNumber = this.$route.query.serialNumber || "";
			this.orderStatus = this.$route.query.orderStatus || "";
			this.staffName = this.$route.query.staffName || "";
			this.isLeader = this.$route.query.isLeader || "2";
			let resp = await dealerOrderService.getRadOrderInfoById(this.uuid);
			if (resp.data.Status === "1" && resp.data.Data){
				this.groupId = resp.data.Data.priceGroupId;
				this.order.customerName = resp.data.Data.customerName;
				this.order.arrivalAddress = resp.data.Data.arrivalAddress;
				this.order.arrivalMobile = resp.data.Data.arrivalMobile;
				this.order.remark = resp.data.Data.remark || "";
				if(this.order.remark && this.order.remark.length > 22){
					let temp = this.order.remark;
					this.order.remark = temp.substring(0, 22);
					this.order.remark += "...";
				}
				this.order.amount = resp.data.Data.amount;
				this.order.mainAmount = resp.data.Data.mainAmount;
				this.order.mainCostAmount = resp.data.Data.mainCostAmount;
				this.order.mainQuantities = resp.data.Data.mainQuantities;
				this.order.createTime = moment(resp.data.Data.createTime).format('YYYY-MM-DD HH:mm');
				if((resp.data.Data.isCreator || "2") === "1" && (resp.data.Data.orderStatus || "") === "10"){
					this.isEditable = true;
				}
			}
		},
        methods: {
			async onLoad() {
				this.pageIndex++;
				let resp = await dealerOrderService.getRadOrderDetailList(this.pageIndex, this.uuid, "");
				resp.data.Data.data.forEach(item => {
					if (item.isSpecials && item.isSpecials.length > 22) {
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 22);
						item.isSpecials += "...";
					}
					if (item.mainRemark && item.mainRemark.length > 22) {
						let temp = item.mainRemark;
						item.mainRemark = temp.substring(0, 22);
						item.mainRemark += "...";
					}
				});
				resp.data.Data.data.forEach(item => {
					item.imageUrl = this.imageUrl + item.imageIds.split(",")[0];
				});
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				this.loading = false;
				this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			editSkuInfo(detailId, radId){
				if(!this.isEditable){
					Toast.fail("只能修改自己未审核的订单！");
					return;
				}
				this.editDetailId = detailId;
				this.editRadId = radId;
				this.showEditType = true;
			},
			updateOrderInfo(){
				this.$router.push({path:"/rad/radDetail",  query:{uuid: this.editDetailId, radId: this.editRadId, groupId: this.groupId, editType: "order"}} );
			},
			async deleteOrderSku(){
				Dialog.confirm({
					title: '',
					message: '确定要将选择的产品删除吗？'
				}).then(() => {
					this.deleteOrderDetail();
				}).catch(() => {
					return;
				});
			},
			async deleteOrderDetail(){
				let resp = await dealerOrderService.deleteOrderDetailById(this.uuid, this.editDetailId);
				if (resp.data.Status === "1"){
					Toast.success("删除成功！");
					this.editDetailId = "";
					this.editRadId = "";
					this.showEditType = false;
					this.onRefresh();
					let orderResp = await dealerOrderService.getRadOrderInfoById(this.uuid);
					if (orderResp.data.Status === "1" && orderResp.data.Data){
						this.order.amount = orderResp.data.Data.amount;
						this.order.mainAmount = orderResp.data.Data.mainAmount;
						this.order.mainCostAmount = orderResp.data.Data.mainCostAmount;
						this.order.mainQuantities = orderResp.data.Data.mainQuantities;
					}
				} else {
					Toast.fail(resp.data.Message);
					this.editDetailId = "";
					this.editRadId = "";
					this.showEditType = false;
					this.onRefresh();
				}
			},
			cancelEditSku(){
				this.editDetailId = "";
				this.editRadId = "";
				this.showEditType = false;
			}
		}
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>